import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AuthLayout, authInput, authBtn, Link } from "../components/AuthLayout";

export default function Register() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/register", { ...f, accept_disclosure: ok });
      signIn(data);
      nav("/");
    } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <AuthLayout title="Open a virtual trading account" noticeTestid="register-notice-text" subtitle="Get ₹10,00,000 virtual capital instantly."
      footer={<>Already have an account? <Link to="/login" className="text-primary font-medium" data-testid="goto-login">Log in</Link></>}>
      <form onSubmit={submit} className="space-y-3" data-testid="register-form">
        <input data-testid="register-name-input" required placeholder="Full name" value={f.name} onChange={upd("name")} className={authInput} />
        <input data-testid="register-email-input" type="email" required placeholder="Email" value={f.email} onChange={upd("email")} className={authInput} />
        <input data-testid="register-password-input" type="password" required minLength={6} placeholder="Password (min 6 characters)" value={f.password} onChange={upd("password")} className={authInput} />
        <label className="flex items-start gap-2 text-[12px] cursor-pointer" data-testid="register-accept-label">
          <input type="checkbox" data-testid="register-accept-checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[hsl(var(--primary))]" />
          <span>I understand and accept the simulated trading notice below</span>
        </label>
        {err && <div className="text-down text-[12px]" data-testid="register-error">{err}</div>}
        <button data-testid="register-submit-button" disabled={busy || !ok} className={authBtn}>{busy ? "Creating account…" : "Create account"}</button>
      </form>
    </AuthLayout>
  );
}
